'use strict';

var _ = require('underscore'),
    AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    ServiceTypes = require('../constants/ServiceTypes'),
    SocialFriendListStore = require('./SocialFriendListStore'),
    { createStore } = require('../utils/StoreUtils'),
    update = require('react/lib/update');

var _recepient = null,
    _suggested = null,
    resentInvites = {},
    _isSending = false,
    _isFormHidden = false,
    _message = null;

var NON_LETTERS_RE = /[\s\.,-\/#!$%\^&\*;:{}=\-_`~()'"“”]/g;

function getDefaultRecipient() {
  return {
    text: '',
    tags: [],
    isEmpty: function () {
      return !this.text;
    }
  };
}

function updateSuggestions(query) {
  var facebookFriends = SocialFriendListStore.getFriends(ServiceTypes.FACEBOOK),
      googleFriends = SocialFriendListStore.getFriends(ServiceTypes.GOOGLE),
      friends = (facebookFriends || []).concat(googleFriends || []),
      queryWords = _.compact(query.toLowerCase().split(NON_LETTERS_RE));

  if (!query) {
    _suggested = [];
    return;
  }

  _suggested = _.filter(friends, function isMatch(friend) {
    return _.every(queryWords, function (queryWord) {
      return _.any(friend.keywords, function (keyword) {
        return keyword.indexOf(queryWord) === 0;
      });
    });
  });
}

function pushTag(tag) {
  _recepient = update(_recepient || getDefaultRecipient(), {
    text: { $set: '' },
    tags: { $push: [tag] }
  });

  _suggested = [];
}

var SendInvitationFormStore = createStore({
  getFormState() {
    return {
      resentInvites: resentInvites,
      isSending: _isSending,
      isFormHidden: _isFormHidden,
      recipient: _recepient || getDefaultRecipient(),
      suggested: _suggested || [],
      message: _message || ''
    };
  }
});

AppDispatcher.register(function (payload) {
  var action = payload.action,
      response = action.response;

  switch (action.type) {
  case ActionTypes.SEND_INVITE:
  case ActionTypes.RESEND_INVITE:
  case ActionTypes.UPDATE_INVITE:
    _isSending = true;
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.SEND_INVITE_ERROR:
  case ActionTypes.RESEND_INVITE_ERROR:
  case ActionTypes.UPDATE_INVITE_ERROR:
    _isSending = false;
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.SEND_INVITE_SUCCESS:
  case ActionTypes.UPDATE_INVITE_SUCCESS:
    _isSending = false;
    _recepient = getDefaultRecipient();
    _message = null;
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.SEND_FB_INVITE:
    _isFormHidden = true;
    _isSending = true;
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.SEND_FB_INVITE_SUCCESS:
    _isSending = false;
    _isFormHidden = false;
    _recepient = getDefaultRecipient();
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.SEND_FB_INVITE_ERROR:
    _isSending = false;
    _isFormHidden = false;
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.RESEND_INVITE_SUCCESS:
    _isSending = false;
    resentInvites[response.result] = true;
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.HIDE_MODAL:
    resentInvites = {};
    break;

  case ActionTypes.FORM_VALUE_CHANGED:
    if (action.key === 'recipient') {
      _recepient = action.value;
      updateSuggestions(_recepient.text);
      SendInvitationFormStore.emitChange();
    } else if (action.key === 'message') {
      _message = action.value;
      SendInvitationFormStore.emitChange();
    }
    break;

  case ActionTypes.INVITATION_FORM_PUSH_TAG:
    pushTag(action.tag);
    SendInvitationFormStore.emitChange();
    break;

  case ActionTypes.INVITATION_FORM_CLEAR_SUGGESTED:
    _suggested = [];
    SendInvitationFormStore.emitChange();
    break;
  }
});

module.exports = SendInvitationFormStore;


/** WEBPACK FOOTER **
 ** ./stores/SendInvitationFormStore.js
 **/